import React from 'react';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

const CheckBox = ({ id, name, value, label, validation, placeholder, className, disabled = false }) => {
  const { register } = useFormContext();

  return (
    <div className="flex mt-1 w-full items-center">
      <input
        id={id}
        disabled={disabled}
        type="checkbox"
        name={name}
        value={value}
        placeholder={placeholder}
        className={twMerge(
          'm-0.5 w-5 h-5 border border-gray-300 cursor-pointer appearance-none',
          'checked:bg-contrast2 checked:hover:bg-contrast1 checked:border-contrast1 checked:focus:bg-contrast2',
          'focus:ring-0 focus:bg-transparent focus:bottom-0',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...register(name, validation)}
      />
      <label className="text-xs ml-2 mb-0 md:text-sm md:mb-1 text-gray-700">{label}</label>
    </div>
  );
};

export default CheckBox;
